import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios"; // Import axios for API calls
import Env from '../../runtimeEnv';

const UpdateMeetingForm = () => {
  const { register, handleSubmit, setValue, reset, watch } = useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null); // For success/error messages

  // Example therapist data (Can be fetched from an API)
  const therapists = [
    { name: "Test User - James", email: "jshu@plutonic.co" },
    { name: "Jeanette Gurr", email: "jgurr@plutonic.co" },
    { name: "Abigail Rozeboom", email: "arozeboom@plutonic.co" },
    { name: "Ashi Patel", email: "apatel@plutonic.co" },
    { name: "Stephanie Branom", email: "sbranom@plutonic.co" },
    { name: "Cooper Morgan", email: "cmorgan@plutonic.co" },
    { name: "Jessica Sigur", email: "jsigur@plutonic.co" },
    { name: "Briauna Brownfield, LMSW", email: "bbrownfield@plutonic.co" },
  ];

  // Watch selected therapist name
  const selectedTherapist = watch("therapist");

  // Auto-fill therapist email when a therapist is selected
  const handleTherapistChange = (event) => {
    const therapistEmail = therapists.find(t => t.name === event.target.value)?.email || "";
    setValue("therapistEmail", therapistEmail);
  };

  // Handle form submission
  const onSubmit = async (data) => {
    setLoading(true);
    setMessage(null);

    // Ensure meetingName is provided (default if missing)
    if (!data.meetingName) {
      data.meetingName = "Therapy Session"; // Default name
    }

  

    // Remove therapistEmail if empty
    if (!data.therapistEmail) {
      delete data.therapistEmail;
    }

    // Construct payload for API request
    const payload = {
      email: data.email,
      // name: data.name || null, // Optional field
      meetingName: data.meetingName, // Ensure meetingName is always included
      sessionTime: data.sessionTime || null, // Optional field
      therapistEmail: data.therapistEmail || null, // Optional field
    };

    // console.log("🔹 Sending Payload to Backend:", payload);

    try {
      const response = await axios.put(
        `${Env.REACT_APP_PYTHON_API_URL}/api/admin/update-meeting`,
        payload
      );
      setMessage({ type: "success", text: response.data.message });
      reset(); // Clear the form on success
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Failed to update Meeting.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {message && (
        <div
          className={`p-2 text-center ${
            message.type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {message.text}
        </div>
      )}

      <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
        {/* User Email */}
        <input
          {...register("email", { required: true })}
          placeholder="Client Email"
          className="input-field"
        />



        {/* Meeting Name */}
        <input
          {...register("meetingName")}
          placeholder="Meeting Name"
          className="input-field"
          
        />

        {/* Session Time */}
        <input
          type="datetime-local"
          {...register("sessionTime")}
          className="input-field"
        />

        {/* Therapist Dropdown */}
        <select
          {...register("therapist")}
          className="input-field"
          onChange={handleTherapistChange}
        >
          <option value="">Select a Therapist</option>
          {therapists.map((therapist, index) => (
            <option key={index} value={therapist.name}>
              {therapist.name}
            </option>
          ))}
        </select>

        {/* Auto-filled Therapist Email */}
        <input
          {...register("therapistEmail")}
          placeholder="Therapist Email"
          readOnly
          className="input-field bg-gray-200 cursor-not-allowed"
        />

        

        {/* Submit Button */}
        <button type="submit" className="button-secondary" disabled={loading}>
          {loading ? "Updating Meeting..." : "Update Meeting"}
        </button>
      </form>
    </>
  );
};

export default UpdateMeetingForm;